<template>
  <div v-if="homeLoader || regionsLoader" class="text-center">
    <mainloader />
  </div>
  <div v-else>
    <div class="home">
      <div class="background-shadow">
        <div class="container padding-container">
          <div class="row justify-content-center pt-4">
            <div class="col text-one">
              <div class="almarai-bold font-40 ps-5">{{ t("home.h1") }}</div>
              <div class="font-20 ps-5">{{ t("home.h2") }}</div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-12 col-md-12">
              <errorAlert
                v-if="searchError"
                :alertMessage="message"
                :errorNumber="errorNumber"
              />
            </div>
          </div>
          <div class="row justify-content-center pt-4">
            <div class="col-12 col-md-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-6 col-md-3">
                      <label for="" class="almarai-bold">{{
                        t("home.ft_1")
                      }}</label>
                      <Select2
                        :placeholder="$t('home.ft_5')"
                        class="search"
                        modelValue="regionId"
                        v-model="regionId"
                        :options="regionsObj"
                        @select="citiesList()"
                      ></Select2>
                    </div>
                    <div class="col-6 col-md-2">
                      <label for="" class="almarai-bold">{{
                        t("home.ft_2")
                      }}</label>
                      <Select2
                        :placeholder="$t('home.ft_6')"
                        class="search"
                        modelValue="city"
                        v-model="city"
                        @click.prevent="checkRegions"
                        :options="cityObj"
                        @select="neighborhoodList()"
                      ></Select2>
                    </div>
                    <div class="col-6 col-md-2">
                      <label for="" class="almarai-bold">{{
                        t("home.ft_3")
                      }}</label>
                      <Select2
                        class="search"
                        modelValue="neighborhood"
                        v-model="neighborhood"
                        @click="checkNeighborhoods"
                        :placeholder="$t('home.ft_7')"
                        :options="itemsOb"
                      ></Select2>
                    </div>
                    <div class="col-6 col-md-3">
                      <label for="" class="almarai-bold">{{
                        t("home.ft_4")
                      }}</label>
                      <Select2
                        class="search"
                        modelValue="propertyTypes"
                        v-model="propertyTypes"
                        :placeholder="$t('home.ft_8')"
                        :options="typeObj"
                      ></Select2>
                    </div>
                    <div
                      class="col-6 col-md-2 text-center button-center position-R"
                    >
                      <router-link :to="'/propertielist/?typeId=' + propertyTypes + '&' +
                          'neighborhoodId=' +
                          neighborhood +
                          '&' +
                          'cityId=' +
                          city +
                          '&' +
                          'regionId=' +
                          regionId
                        "
                      >
                        <button
                          class="btn-Green-3E border-0"
                        >
                          {{ t("home.fb") }}
                        </button>
                        <!-- <i class="fa-solid fa-sliders icon-color"></i> -->
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="hasError">
      <errorAlert :alertMessage="message" :errorNumber='errorNumber' />
    </div>
    <div class="container">
      <div v-if="GET_USER && currentOrder && currentOrdersCount == 1" class="row pt-3">
        <div class="col">
          <div class="card orderTracking">
            <div>
              <img src="/assets/images/icons/logo-1.png" class="slogan" alt="">
            </div>
            <div class="card-body">
              <div class="row" v-if="currentOrder.status == 'new'">
                <div class="col">
                  <div class="technician-styleHome">
                    <span>{{$t('maintenances.technician')}}</span>
                    <span class="mx-1">🔍</span>
                  </div>
                  <div class="confirmed">{{$t('searchingTechnician')}}</div>
                </div>
                <div class="col-auto content-center">
                  <router-link class="trackOrder" :to="'/maintenancedetails/'+currentOrder.id">
                    {{$t('TrackRequest')}}
                  </router-link>
                </div>
              </div>

              <div class="row" v-if="currentOrder.status == 'assigned'">
                <div class="col">
                  <div>
                    <img src="/assets/images/icons/moto.png" class="search-Icon" alt="">
                  </div>
                  <div class="technician-style technician-style-status">
                    <!-- <span>{{$t('maintenances.technician')}}</span> -->
                    <span>{{$t('maintenanceDetails.theTechnician')}}</span>
                    <span class="mx-1">🔧</span>
                  </div>
                  <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                  <div class="confirmed">{{$t('maintenances.area')}}</div>
                </div>
                <div class="col-auto content-center">
                  <router-link class="trackOrder" :to="'/maintenancedetails/'+currentOrder.id">
                    {{$t('TrackRequest')}}
                  </router-link>
                </div>
              </div>

              <div class="row" v-if="currentOrder.status == 'arrived'">
                <div class="col">
                  <div>
                    <img src="/assets/images/icons/worker-yellow.png" style="width: 100px;" alt="">
                  </div>
                  <div class="technician-style technician-style-status">
                    <span>{{$t('maintenanceDetails.theTechnician')}}</span>
                    <span class="mx-1">🔧</span>
                  </div>
                  <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                  <div class="confirmed">{{$t('maintenances.area')}}</div>
                </div>
                <div class="col-auto content-center">
                  <router-link class="trackOrder" :to="'/maintenancedetails/'+currentOrder.id">
                    <div>{{$t('TrackRequest')}}</div>
                  </router-link>
                </div>
              </div>

              <div class="row" v-if="currentOrder.status == 'done'">
                <div class="col">
                  <div>
                    <img src="/assets/images/icons/trueIcon.png" class="search-Icon" alt="">
                  </div>
                  <div class="technician-style technician-style-status">
                    <span>{{$t('maintenanceDetails.successfullyResolved')}}</span>
                  </div>
                  <!-- <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                  <div class="confirmed">{{$t('maintenances.area')}}</div> -->
                </div>
              </div>
              <div class="row" v-if="['done', 'new', 'assigned', 'arrived'].indexOf(currentOrder.status) == -1">
                <div class="col">
                  <div class="technician-styleHome">{{ $t('maintenances.hasOrder') }}</div>
                  <div class="technician-style technician-style-status">
                    <img src="/assets/images/icons/wating_img.png" class="search-Icon" alt=""> 
                    {{orderStatus[currentOrder.status]}}
                  </div>
                  <!-- <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                  <div class="confirmed">{{$t('maintenances.area')}}</div> -->
                </div>
                <div class="col-auto">
                  <router-link class="trackOrder d-block" :to="'/maintenancedetails/'+currentOrder.id">
                    {{$t('TrackRequest')}}
                  </router-link>
                </div>
              </div>
              <div class="row pt-4">
                <div class="col">
                  <!-- <span class="statusLineHome bg-Orange"></span>
                  <span class="statusLineHome bg-Orange"></span>
                  <span class="statusLineHome bg-Orange"></span>
                  <span class="statusLineHome bg-Orange"></span> -->
                  <span :class="(['new', 'assigned', 'arrived', 'done'].indexOf(currentOrder.status) != -1)? 'statusLineHome bg-Orange':'statusLineHome'"></span>
                  <span :class="(['assigned', 'arrived', 'done'].indexOf(currentOrder.status) != -1)? 'statusLineHome bg-Orange':'statusLineHome'"></span>
                  <span :class="(['arrived', 'done'].indexOf(currentOrder.status) != -1)? 'statusLineHome bg-Orange':'statusLineHome'"></span>
                  <span :class="(['done'].indexOf(currentOrder.status) != -1)? 'statusLineHome bg-Orange':'statusLineHome'"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="GET_USER && currentOrdersCount > 1" class="row pt-3">
        <div class="col">
          <div class="card orderTracking">
            <div>
              <img src="/assets/images/icons/logo-1.png" class="slogan" alt="">
            </div>
            <div class="card-body">
              <div class="row p-4">
                <div class="col technician-styleHome">
                  {{$t('home.maintenanceRequests')}}
                </div>
                <div class="col-auto content-center d-block">
                  <router-link class="trackOrder" to="/maintenanceslist">
                    {{$t('trackOrders')}}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center pt-4">
        <div class="col position-R">
          <div
            id="carouselExampleAutoplaying"
            class="carousel slide"
          >
            <div class="carousel-indicators">
              <button
                v-for="(img, index) in homeBanners"
                :key="index"
                type="button"
                data-bs-target="#carouselExample"
                :data-bs-slide-to="index"
                :class="{ active: index === 0 }"
                :aria-current="index === 0 ? 'true' : null"
              ></button>
            </div>
            <div class="carousel-inner">
              <div
                v-for="(banner, index) in homeBanners"
                :key="index"
                :class="index == 0 ? 'carousel-item active' : 'carousel-item'"
              >
                <a v-if="banner.actionType == 'link'" :href="banner.action">
                  <img
                    :src="MEDIA_URL + banner.path"
                    class="d-block w-100 banner-img"
                    alt="..."
                  />
                </a>
                <router-link
                  v-if="banner.actionType == 'page'"
                  :to="
                    banner.action == 'manage_property_services'
                      ? '/propertymanagement'
                      : banner.action == 'advertising'
                      ? '/propertiecreate'
                      : banner.action == 'maintenance'
                      ? '/maintenances'
                      : banner.action == 'property_request'
                      ? '/propertyrequest'
                      : '#'
                  "
                >
                  <img
                    :src="MEDIA_URL + banner.path"
                    class="d-block w-100 banner-img"
                    alt="..."
                  />
                </router-link>
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
          <!-- <div class="card balck-bg post card-black">
            <div class="card-body padding-zero">
              <div class="row">
                <div class="col">
                  <h6>{{t('home.banner_h1')}}</h6>
                  <p class="fonttext-14">{{t('home.banner_h2')}}</p>
                </div>
                <div v-if="GET_USER" class="col-auto pt-2">
                  <router-link to="/propertymanagement">
                    <button class="buttonStyle button-padding">{{t('home.banner_b')}}</button>
                  </router-link>
                </div>
                <div v-else class="col-auto pt-2">
                  <button @click="poupLogin" class="buttonStyle button-padding">{{t('home.banner_b')}}</button>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <div class="row pt-4">
        <div class="col">
          <div class="row pt-3">
            <div class="col">
              <i class="fa-regular fa-map"></i>
              <span class="almarai-bold mx-2">{{ t("home.title_1") }}</span>
            </div>
            <!-- <div class="col-4 changeText  button-center">
              <router-link :to="'/citiesList?cityId='+homeCity.id">
                <span class="orange-font">{{t('home.title_2')}}</span>
              </router-link>
            </div> -->
          </div>
          <div class="row pt-3 scroll-row">
            <div
              class="col-auto mouse-hand"
              v-for="(row, index) in homeRegionsList"
              :key="index"
            >
              <div>
                <router-link :to="'/propertielist?regionId=' + row.id">
                  <img v-if="row.cover" :src="MEDIA_URL + row.cover" class="style-img" alt=""/>
                  <img v-else src="/assets/images/placeHolder.jpeg" class="style-img" alt="" />
                  <!-- <div>{{ row.name }}</div> -->
                </router-link>
              </div>
              <!-- <div v-else @click="activeRegion">
                <img v-if="row.cover" :src="MEDIA_URL + row.cover" class="style-img" alt=""/>
                <img v-else src="/assets/images/placeHolder.jpeg" class="style-img" alt="" />
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="row pt-4 justify-content-center" v-if="properties.length">
        <div class="col">
          <div class="row">
            <div class="col space">
              <img
                src="/assets/images/global-search.png"
                class="img-fluid"
                alt=""
              />
              <span class="almarai-bold mx-2">{{ t("home.title_3") }}</span>
            </div>
            <div class="col changeText">
              <router-link :to="'/nearproperties?latitude=' +latitude +'&' +'longitude=' +longitude">
                <div>{{
                  t("home.title_2")}}
                </div>
              </router-link>
            </div>
          </div>

          <div class="row pt-3 display-card">
            <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(prop, inde) in properties" :key="inde">
              <div class="card card-border m-auto" v-if="prop.status == 'rented' || prop.status == 'sold'">
                <div class="card-body position-R">
                  <div class="row reservedProperty"> 
                    <div class="col-auto rented" v-if="prop.status == 'rented'">
                      <span>{{$t('rentedOut')}}</span>
                      <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                    </div>
                    <div class="col-auto soldProp" v-if="prop.status == 'sold'">
                      <span>{{$t('Sold')}}</span>
                      <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                    </div>
                  </div>
                  <div class="row statusBar">
                    <div class="col-auto tag-style">
                      <span class="">{{ prop.PropertyType?.name }}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{
                        homeStatusChoices[prop.status]
                      }}</span>
                    </div>
                  </div>


                  
                  <swiper
                    v-if="prop.mediaFiles.length"
                    class="text-center"
                    :modules="[Autoplay, Navigation, Pagination]"
                    :pagination="{ clickable: true }"
                    :spaceBetween="30"
                    :centeredSlides="true"
                    :autoplay="{ delay: 2500, disableOnInteraction: false }"
                    :navigation="false"
                  >
                    <swiper-slide
                      v-for="(row, index) in prop.mediaFiles"
                      :key="index"
                    >
                      <img
                        :src="MEDIA_URL + row.thumbnail"
                        alt="Slide Image"
                        class="w-100 br-radius"
                      />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <placeHolder />
                  </div>
                  <div class="text-title">{{ prop.title }}</div>

                  <div class="row pt-1">
                    <div class="col-auto px-2 content-center">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                    </div>
                    <div class="col p-0 fontGray-73 content-center">
                      <div class="d-flex">
                        {{ prop.City?.name }}
                        <span class="mx-1">{{ prop.Neighborhood?.name }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="d-flex pt-2">
                    <i class="fa-solid fa-location-dot gray-color"></i>
                    <div class="mx-2 gray-color fonttext-14">
                      {{ prop.City?.name }}
                    </div>
                    <div class="gray-color fonttext-14">
                      {{ prop.Neighborhood?.name }}
                    </div>
                  </div> -->
                  <hr class="border-color-w" />
                  <div class="row end-card space">
                    <div class="col content-center">
                      <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      <span v-if="prop.price" class="green-color-F almarai-bold">{{
                        prop.price
                      }}</span>
                    </div>
                    <div class="col-auto content-center" v-if="prop.roomsCount && prop.bathrooms">
                      <div class="row">
                        <div class="col-auto content-center">
                          <span> 
                            <img :src="MEDIA_URL + homeCountedIcons.roomsCount.path" 
                              class="max-width-28"
                              alt=""/>
                          </span>
                          <span class="numbers">{{ prop.roomsCount }}</span>
                        </div>
                        <div class="col-auto border_Icons">
                          <span>
                            <img :src="MEDIA_URL + homeCountedIcons.bathrooms.path"
                              class="max-width-28"
                              alt=""/>
                          </span>
                          <span class="numbers">{{ prop.bathrooms }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col-auto content-center">
                      <span>
                        <img :src="MEDIA_URL + homeCountedIcons.area.path"
                          class="max-width-28"
                          alt=""/>
                      </span>
                      <span class="numbers">
                        {{ prop.area }}
                        <span>{{ $t("areaSymbol") }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-border m-auto" v-if="prop.status == 'available'">
                <router-link :to="'/propertydetails/' + prop.id +'?propertyType=property'">
                  <!-- <div class="padding-4p almarai-regular position-R">
                  </div> -->
                  <div class="card-body position-R">
                    <div class="row statusBar">
                      <div class="col-auto tag-style">
                        <span class="">{{ prop.PropertyType?.name }}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{
                          homeStatusChoices[prop.status]
                        }}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{
                          prop.purpose == "for_rent"
                            ? $t("rent")
                            : prop.purpose == "for_sale"
                            ? $t("sale")
                            : $t("investment")
                        }}</span>
                      </div>
                    </div>
                    <span
                      v-if="prop.Favorites && prop.Favorites.length"
                      class="heart-icon"
                      @click.prevent="
                        removeFavorite(prop.id, 'properties', inde)
                      "
                    >
                      <i class="fa-solid fa-heart orange-Heart"></i>
                    </span>
                    <span
                      v-else
                      class="heart-icon"
                      @click.prevent="addFavorite(prop.id, 'properties', inde)"
                    >
                      <i class="fa-solid fa-heart heart"></i>
                    </span>
                    <swiper
                      v-if="prop.mediaFiles.length"
                      class="text-center"
                      :modules="[Autoplay, Navigation, Pagination]"
                      :pagination="{ clickable: true }"
                      :spaceBetween="30"
                      :centeredSlides="true"
                      :autoplay="{ delay: 2500, disableOnInteraction: false }"
                      :navigation="false"
                    >
                      <swiper-slide
                        v-for="(row, index) in prop.mediaFiles"
                        :key="index"
                      >
                        <img
                          :src="MEDIA_URL + row.thumbnail"
                          alt="Slide Image"
                          class="w-100 br-radius"
                        />
                      </swiper-slide>
                    </swiper>
                    <div v-else>
                      <placeHolder />
                    </div>
                    <div class="text-title">{{ prop.title }}</div>

                    <div class="row pt-1">
                      <div class="col-auto px-2 content-center">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                      </div>
                      <div class="col p-0 fontGray-73 content-center">
                        <div class="d-flex">
                          {{ prop.City?.name }}
                          <span class="mx-1">{{ prop.Neighborhood?.name }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="d-flex pt-2">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                      <div class="mx-2 gray-color fonttext-14">
                        {{ prop.City?.name }}
                      </div>
                      <div class="gray-color fonttext-14">
                        {{ prop.Neighborhood?.name }}
                      </div>
                    </div> -->
                    <hr class="border-color-w" />
                    <div class="row end-card space">
                      <div class="col content-center">
                        <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                        <span v-if="prop.price" class="green-color-F almarai-bold">{{
                          prop.price
                        }}</span>
                      </div>
                      <div class="col-auto content-center" v-if="prop.roomsCount && prop.bathrooms">
                        <div class="row">
                          <div class="col-auto content-center">
                            <span> 
                              <img :src="MEDIA_URL + homeCountedIcons.roomsCount.path" 
                                class="max-width-28"
                                alt=""/>
                            </span>
                            <span class="numbers">{{ prop.roomsCount }}</span>
                          </div>
                          <div class="col-auto border_Icons">
                            <span>
                              <img :src="MEDIA_URL + homeCountedIcons.bathrooms.path"
                                class="max-width-28"
                                alt=""/>
                            </span>
                            <span class="numbers">{{ prop.bathrooms }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="col-auto content-center">
                        <span>
                          <img :src="MEDIA_URL + homeCountedIcons.area.path"
                            class="max-width-28"
                            alt=""/>
                        </span>
                        <span class="numbers">
                          {{ prop.area }}
                          <span>{{ $t("areaSymbol") }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row pt-4" v-if="homeFeaturedProperties.length">
        <div class="col">
          <div class="row">
            <div class="col-8">
              <i class="fa-regular fa-star"></i>
              <span class="almarai-bold mx-2">{{ t("home.title_4") }}</span>
            </div>
            <div class="col-4 changeText">
              <router-link :to="'/propertielist?isFeatured=true'">
                <div>{{ t("home.title_2") }}</div>
              </router-link>
            </div>
          </div>

          <div class="row pt-3 display-card">
            <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(val, index) in homeFeaturedProperties" :key="index">
              <div class="card card-border m-auto" v-if="val.status == 'rented' || val.status == 'sold'">
                <div class="card-body position-R">
                  <div class="row reservedProperty"> 
                    <div class="col-auto rented" v-if="val.status == 'rented'">
                      <span>{{$t('rentedOut')}}</span>
                      <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                    </div>
                    <div class="col-auto soldProp" v-if="val.status == 'sold'">
                      <span>{{$t('Sold')}}</span>
                      <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                    </div>
                  </div>
                  <div class="row statusBar">
                    <div class="col-auto tag-style">
                      <span class="">{{ val.PropertyType?.name }}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{
                        homeStatusChoices[val.status]
                      }}</span>
                    </div>
                  </div>

                  <swiper
                    v-if="val.mediaFiles.length"
                    class="text-center"
                    :modules="[Autoplay, Navigation, Pagination]"
                    :autoplay="{ delay: 2500, disableOnInteraction: false }"
                    :pagination="{ clickable: true }"
                    :navigation="false"
                  >
                    <swiper-slide
                      v-for="(img, ind) in val.mediaFiles"
                      :key="ind"
                    >
                      <img
                        :src="MEDIA_URL + img.thumbnail"
                        alt="Slide Image"
                        class="w-100 br-radius"
                      />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <placeHolder />
                  </div>
                  <div class="text-title">{{ val.title }}</div>

                  <div class="row pt-1">
                    <div class="col-auto px-2 content-center">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                    </div>
                    <div class="col p-0 fontGray-73 content-center">
                      <div class="d-flex">
                        {{ val.City?.name }}
                        <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="d-flex pt-2">
                    <i class="fa-solid fa-location-dot gray-color"></i>
                    <div class="mx-2 gray-color fonttext-14">
                      {{ val.City?.name }}
                    </div>
                    <div class="gray-color fonttext-14">
                      {{ val.Neighborhood?.name }}
                    </div>
                  </div> -->
                  <hr class="border-color-w" />
                  <div class="row end-card space">
                    <div class="col content-center">
                      <span
                        class="mx-1 green-color-F icon-saudi_riyal_bold_new"
                      ></span>
                      <span v-if="val.price" class="green-color-F almarai-bold">
                        {{val.price}}
                      </span>
                    </div>

                    <div
                      class="col-auto content-center"
                      v-if="val.roomsCount && val.bathrooms"
                    >
                      <div class="row">
                        <div class="col-auto content-center">
                          <span>
                            <img :src="MEDIA_URL+homeCountedIcons.roomsCount.path"
                              class="max-width-28" alt=""/>
                          </span>
                          <span class="numbers">{{ val.roomsCount }}</span>
                        </div>
                        <div class="col-auto border_Icons">
                          <span
                            ><img
                              :src="
                                MEDIA_URL + homeCountedIcons.bathrooms.path
                              "
                              class="max-width-28"
                              alt=""
                          /></span>
                          <span class="numbers">{{ val.bathrooms }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col-auto content-center">
                      <span
                        ><img
                          :src="MEDIA_URL + homeCountedIcons.area.path"
                          class="max-width-28"
                          alt=""
                      /></span>
                      <span class="numbers"
                        >{{ val.area }}
                        <span>{{ $t("areaSymbol") }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-border m-auto" v-if="val.status == 'available'">
                <router-link :to="'/propertydetails/' + val.id+ '?propertyType=property'">
                  <div class="card-body position-R">
                    <div class="row statusBar">
                      <div class="col-auto tag-style">
                        <span class="">{{ val.PropertyType?.name }}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{
                          homeStatusChoices[val.status]
                        }}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{
                          val.purpose == "for_rent"
                            ? $t("rent")
                            : val.purpose == "for_sale"
                            ? $t("sale")
                            : $t("investment")
                        }}</span>
                      </div>
                    </div>
                    <span
                      class="heart-icon"
                      v-if="val.Favorites && val.Favorites.length"
                      @click.prevent="
                        removeFavorite(val.id, 'featuredProperties', index)
                      "
                    >
                      <i class="fa-solid fa-heart orange-Heart"></i>
                    </span>
                    <span
                      @click.prevent="
                        addFavorite(val.id, 'featuredProperties', index)
                      "
                      v-else
                      class="heart-icon"
                    >
                      <i class="fa-solid fa-heart heart"></i>
                    </span>
                    <swiper
                      v-if="val.mediaFiles.length"
                      class="text-center"
                      :modules="[Autoplay, Navigation, Pagination]"
                      :autoplay="{ delay: 2500, disableOnInteraction: false }"
                      :pagination="{ clickable: true }"
                      :navigation="false"
                    >
                      <swiper-slide
                        v-for="(img, ind) in val.mediaFiles"
                        :key="ind"
                      >
                        <img
                          :src="MEDIA_URL + img.thumbnail"
                          alt="Slide Image"
                          class="w-100 br-radius"
                        />
                      </swiper-slide>
                    </swiper>
                    <div v-else>
                      <placeHolder />
                    </div>
                    <div class="text-title">{{ val.title }}</div>

                    <div class="row pt-1">
                      <div class="col-auto px-2 content-center">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                      </div>
                      <div class="col p-0 fontGray-73 content-center">
                        <div class="d-flex">
                          {{ val.City?.name }}
                          <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="d-flex pt-2">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                      <div class="mx-2 gray-color fonttext-14">
                        {{ val.City?.name }}
                      </div>
                      <div class="gray-color fonttext-14">
                        {{ val.Neighborhood?.name }}
                      </div>
                    </div> -->
                    <hr class="border-color-w" />
                    <div class="row end-card space">
                      <div class="col content-center">
                        <span
                          class="mx-1 green-color-F icon-saudi_riyal_bold_new"
                        ></span>
                        <span v-if="val.price" class="green-color-F almarai-bold">
                          {{val.price}}
                        </span>
                      </div>

                      <div
                        class="col-auto content-center"
                        v-if="val.roomsCount && val.bathrooms"
                      >
                        <div class="row">
                          <div class="col-auto content-center">
                            <span>
                              <img :src="MEDIA_URL+homeCountedIcons.roomsCount.path"
                                class="max-width-28" alt=""/>
                            </span>
                            <span class="numbers">{{ val.roomsCount }}</span>
                          </div>
                          <div class="col-auto border_Icons">
                            <span
                              ><img
                                :src="
                                  MEDIA_URL + homeCountedIcons.bathrooms.path
                                "
                                class="max-width-28"
                                alt=""
                            /></span>
                            <span class="numbers">{{ val.bathrooms }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="col-auto content-center">
                        <span
                          ><img
                            :src="MEDIA_URL + homeCountedIcons.area.path"
                            class="max-width-28"
                            alt=""
                        /></span>
                        <span class="numbers"
                          >{{ val.area }}
                          <span>{{ $t("areaSymbol") }}</span></span
                        >
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row pt-4" v-if="homeFamiliesProperties.length">
        <div class="col">
          <div class="row">
            <div class="col-8 space">
              <i class="fa-solid fa-user-group"></i>
              <span class="almarai-bold mx-2">{{ t("home.title_5") }}</span>
            </div>
            <div class="col-4 changeText orange-font">
              <router-link :to="'/propertielist?propertyType=families'">
                <div>{{ t("home.title_2") }}</div>
              </router-link>
            </div>
          </div>
          <div class="row pt-3 display-card">
            <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(val, index) in homeFamiliesProperties" :key="index">
              <div class="card card-border m-auto" v-if="val.status == 'rented' || val.status == 'sold'">
                <div class="card-body position-R">
                  <div class="row reservedProperty"> 
                    <div class="col-auto rented" v-if="val.status == 'rented'">
                      <span>{{$t('rentedOut')}}</span>
                      <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                    </div>
                    <div class="col-auto soldProp" v-if="val.status == 'sold'">
                      <span>{{$t('Sold')}}</span>
                      <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                    </div>
                  </div>
                  <div class="row statusBar">
                    <div class="col-auto tag-style">
                      <span class="">{{ val.PropertyType?.name }}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{
                        homeStatusChoices[val.status]
                      }}</span>
                    </div>
                  </div>

                  <swiper
                    v-if="val.mediaFiles.length"
                    class="text-center"
                    :modules="[Autoplay, Navigation, Pagination]"
                    :autoplay="{ delay: 2500, disableOnInteraction: false }"
                    :pagination="{ clickable: true }"
                    :navigation="false"
                  >
                    <swiper-slide
                      v-for="(img, ind) in val.mediaFiles"
                      :key="ind"
                    >
                      <img
                        :src="MEDIA_URL + img.thumbnail"
                        alt="Slide Image"
                        class="w-100 br-radius"
                      />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <placeHolder />
                  </div>
                  <div class="text-title">{{ val.title }}</div>
                  <div class="row pt-1">
                    <div class="col-auto px-2 content-center">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                    </div>
                    <div class="col p-0 fontGray-73 content-center">
                      <div class="d-flex">
                        {{ val.City?.name }}
                        <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="d-flex pt-2">
                    <i class="fa-solid fa-location-dot gray-color"></i>
                    <div class="mx-2 gray-color fonttext-14">
                      {{ val.City?.name }}
                    </div>
                    <div class="gray-color fonttext-14">
                      {{ val.Neighborhood?.name }}
                    </div>
                  </div> -->
                  <hr class="border-color-w" />
                  <div class="row end-card space">
                    <div class="col content-center">
                      <span
                        class="mx-1 green-color-F icon-saudi_riyal_bold_new"
                      ></span>
                      <span v-if="val.price" class="green-color-F almarai-bold">
                        {{val.price}}
                      </span>
                    </div>

                    <div
                      class="col-auto content-center"
                      v-if="val.roomsCount && val.bathrooms"
                    >
                      <div class="row">
                        <div class="col-auto content-center">
                          <span>
                            <img :src="MEDIA_URL + homeCountedIcons.roomsCount.path"
                              class="max-width-28"
                              alt=""/>
                          </span>
                          <span class="numbers">{{ val.roomsCount }}</span>
                        </div>
                        <div class="col-auto border_Icons">
                          <span
                            ><img
                              :src="
                                MEDIA_URL + homeCountedIcons.bathrooms.path
                              "
                              class="max-width-28"
                              alt=""
                          /></span>
                          <span class="numbers">{{ val.bathrooms }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col-auto content-center">
                      <span
                        ><img
                          :src="MEDIA_URL + homeCountedIcons.area.path"
                          class="max-width-28"
                          alt=""
                      /></span>
                      <span class="numbers"
                        >{{ val.area }}
                        <span>{{ $t("areaSymbol") }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-border m-auto" v-if="val.status == 'available'">
                <router-link :to="'/propertydetails/' + val.id + '?propertyType=property'">
                  <div class="card-body position-R">
                    <div class="row statusBar">
                      <div class="col-auto tag-style">
                        <span class="">{{ val.PropertyType?.name }}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{
                          homeStatusChoices[val.status]
                        }}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{
                          val.purpose == "for_rent"
                            ? $t("rent")
                            : val.purpose == "for_sale"
                            ? $t("sale")
                            : $t("investment")
                        }}</span>
                      </div>
                    </div>
                    <span
                      v-if="val.Favorites && val.Favorites.length"
                      @click.prevent="
                        removeFavorite(val.id, 'familiesProperties', index)
                      "
                      class="heart-icon"
                    >
                      <i class="fa-solid fa-heart orange-Heart"></i>
                    </span>
                    <span
                      v-else
                      class="heart-icon"
                      @click.prevent="
                        addFavorite(val.id, 'familiesProperties', index)
                      "
                    >
                      <i class="fa-solid fa-heart heart"></i>
                    </span>
                    <swiper
                      v-if="val.mediaFiles.length"
                      class="text-center"
                      :modules="[Autoplay, Navigation, Pagination]"
                      :autoplay="{ delay: 2500, disableOnInteraction: false }"
                      :pagination="{ clickable: true }"
                      :navigation="false"
                    >
                      <swiper-slide
                        v-for="(img, ind) in val.mediaFiles"
                        :key="ind"
                      >
                        <img
                          :src="MEDIA_URL + img.thumbnail"
                          alt="Slide Image"
                          class="w-100 br-radius"
                        />
                      </swiper-slide>
                    </swiper>
                    <div v-else>
                      <placeHolder />
                    </div>
                    <div class="text-title">{{ val.title }}</div>
                    <div class="row pt-1">
                      <div class="col-auto px-2 content-center">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                      </div>
                      <div class="col p-0 fontGray-73 content-center">
                        <div class="d-flex">
                          {{ val.City?.name }}
                          <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="d-flex pt-2">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                      <div class="mx-2 gray-color fonttext-14">
                        {{ val.City?.name }}
                      </div>
                      <div class="gray-color fonttext-14">
                        {{ val.Neighborhood?.name }}
                      </div>
                    </div> -->
                    <hr class="border-color-w" />
                    <div class="row end-card space">
                      <div class="col content-center">
                        <span
                          class="mx-1 green-color-F icon-saudi_riyal_bold_new"
                        ></span>
                        <span v-if="val.price" class="green-color-F almarai-bold">
                          {{val.price}}
                        </span>
                      </div>

                      <div
                        class="col-auto content-center"
                        v-if="val.roomsCount && val.bathrooms"
                      >
                        <div class="row">
                          <div class="col-auto content-center">
                            <span>
                              <img :src="MEDIA_URL + homeCountedIcons.roomsCount.path"
                                class="max-width-28"
                                alt=""/>
                            </span>
                            <span class="numbers">{{ val.roomsCount }}</span>
                          </div>
                          <div class="col-auto border_Icons">
                            <span
                              ><img
                                :src="
                                  MEDIA_URL + homeCountedIcons.bathrooms.path
                                "
                                class="max-width-28"
                                alt=""
                            /></span>
                            <span class="numbers">{{ val.bathrooms }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="col-auto content-center">
                        <span
                          ><img
                            :src="MEDIA_URL + homeCountedIcons.area.path"
                            class="max-width-28"
                            alt=""
                        /></span>
                        <span class="numbers"
                          >{{ val.area }}
                          <span>{{ $t("areaSymbol") }}</span></span
                        >
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row pt-4" v-if="homeSinglesProperties.length">
        <div class="col-12">
          <div class="row">
            <div class="col">
              <i class="bi bi-people font-22"></i>
              <span class="almarai-bold mx-2">{{ t("home.title_6") }}</span>
            </div>
            <div class="col changeText">
              <router-link :to="'/propertielist?propertyType=singles'">
                <div>{{ t("home.title_2") }}</div>
              </router-link>
            </div>
          </div>
          <div class="row pt-3 display-card">
            <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(val, index) in homeSinglesProperties" :key="index">
              <div class="card card-border m-auto" v-if="val.status == 'rented' || val.status == 'sold'">
                <div class="card-body position-R">
                  <div class="row reservedProperty"> 
                    <div class="col-auto rented" v-if="val.status == 'rented'">
                      <span>{{$t('rentedOut')}}</span>
                      <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                    </div>
                    <div class="col-auto soldProp" v-if="val.status == 'sold'">
                      <span>{{$t('Sold')}}</span>
                      <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                    </div>
                  </div>
                  <div class="row statusBar">
                    <div class="col-auto tag-style">
                      <span class="">{{ val.PropertyType?.name }}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{
                        homeStatusChoices[val.status]
                      }}</span>
                    </div>
                  </div>
                  <swiper
                    v-if="val.mediaFiles.length"
                    class="text-center"
                    :modules="[Autoplay, Navigation, Pagination]"
                    :autoplay="{ delay: 2500, disableOnInteraction: false }"
                    :pagination="{ clickable: true }"
                    :navigation="false"
                  >
                    <swiper-slide
                      v-for="(img, ind) in val.mediaFiles"
                      :key="ind"
                    >
                      <img
                        :src="MEDIA_URL + img.thumbnail"
                        alt="Slide Image"
                        class="w-100 br-radius"
                      />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <placeHolder />
                  </div>
                  <div class="text-title">{{ val.title }}</div>
                  <div class="row pt-1">
                    <div class="col-auto px-2 content-center">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                    </div>
                    <div class="col p-0 fontGray-73 content-center">
                      <div class="d-flex">
                        {{ val.City?.name }}
                        <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="d-flex pt-2">
                    <i class="fa-solid fa-location-dot gray-color"></i>
                    <div class="mx-2 gray-color fonttext-14">
                      {{ val.City?.name }}
                    </div>
                    <div class="gray-color fonttext-14">
                      {{ val.Neighborhood?.name }}
                    </div>
                  </div> -->
                  <hr class="border-color-w" />
                  <div class="row end-card space">
                    <div class="col content-center">
                      <span
                        class="mx-1 green-color-F icon-saudi_riyal_bold_new"
                      ></span>
                      <span v-if="val.price" class="green-color-F almarai-bold">{{
                        val.price
                      }}</span>
                    </div>

                    <div class="col-auto content-center" v-if="val.roomsCount && val.bathrooms">
                      <div class="row">
                        <div class="col-auto content-center">
                          <span>
                            <img :src="MEDIA_URL + homeCountedIcons.roomsCount.path" 
                              class="max-width-28" alt=""/>
                          </span>
                          <span class="numbers">{{ val.roomsCount }}</span>
                        </div>
                        <div class="col-auto border_Icons">
                          <span>
                            <img :src="MEDIA_URL + homeCountedIcons.bathrooms.path"
                              class="max-width-28" alt=""/>
                          </span>
                          <span class="numbers">{{ val.bathrooms }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col-auto content-center">
                      <span> 
                        <img :src="MEDIA_URL + homeCountedIcons.area.path" class="max-width-28" alt=""/>
                        </span>
                      <span class="numbers">
                        {{ val.area }}
                      <span>{{ $t("areaSymbol") }}</span></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-border m-auto" v-if="val.status == 'available'">
                <router-link :to="'/propertydetails/' + val.id">
                  <div class="card-body position-R">
                    <div class="row statusBar">
                      <div class="col-auto tag-style">
                        <span class="">{{ val.PropertyType?.name }}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{
                          homeStatusChoices[val.status]
                        }}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{
                          val.purpose == "for_rent"
                            ? $t("rent")
                            : val.purpose == "for_sale"
                            ? $t("sale")
                            : $t("investment")
                        }}</span>
                      </div>
                    </div>
                    <span
                      class="heart-icon"
                      v-if="val.Favorites && val.Favorites.length"
                      @click.prevent="
                        removeFavorite(val.id, 'singlesProperties', index)
                      "
                    >
                      <i class="fa-solid fa-heart orange-Heart"></i>
                    </span>
                    <span
                      class="heart-icon"
                      v-else
                      @click.prevent="
                        addFavorite(val.id, 'singlesProperties', index)
                      "
                    >
                      <i class="fa-solid fa-heart heart"></i>
                    </span>
                    <swiper
                      v-if="val.mediaFiles.length"
                      class="text-center"
                      :modules="[Autoplay, Navigation, Pagination]"
                      :autoplay="{ delay: 2500, disableOnInteraction: false }"
                      :pagination="{ clickable: true }"
                      :navigation="false"
                    >
                      <swiper-slide
                        v-for="(img, ind) in val.mediaFiles"
                        :key="ind"
                      >
                        <img
                          :src="MEDIA_URL + img.thumbnail"
                          alt="Slide Image"
                          class="w-100 br-radius"
                        />
                      </swiper-slide>
                    </swiper>
                    <div v-else>
                      <placeHolder />
                    </div>
                    <div class="text-title">{{ val.title }}</div>
                    <div class="row pt-1">
                      <div class="col-auto px-2 content-center">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                      </div>
                      <div class="col p-0 fontGray-73 content-center">
                        <div class="d-flex">
                          {{ val.City?.name }}
                          <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="d-flex pt-2">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                      <div class="mx-2 gray-color fonttext-14">
                        {{ val.City?.name }}
                      </div>
                      <div class="gray-color fonttext-14">
                        {{ val.Neighborhood?.name }}
                      </div>
                    </div> -->
                    <hr class="border-color-w" />
                    <div class="row end-card space">
                      <div class="col content-center">
                        <span
                          class="mx-1 green-color-F icon-saudi_riyal_bold_new"
                        ></span>
                        <span v-if="val.price" class="green-color-F almarai-bold">{{
                          val.price
                        }}</span>
                      </div>

                      <div class="col-auto content-center" v-if="val.roomsCount && val.bathrooms">
                        <div class="row">
                          <div class="col-auto content-center">
                            <span>
                              <img :src="MEDIA_URL + homeCountedIcons.roomsCount.path" 
                                class="max-width-28" alt=""/>
                            </span>
                            <span class="numbers">{{ val.roomsCount }}</span>
                          </div>
                          <div class="col-auto border_Icons">
                            <span>
                              <img :src="MEDIA_URL + homeCountedIcons.bathrooms.path"
                                class="max-width-28" alt=""/>
                            </span>
                            <span class="numbers">{{ val.bathrooms }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="col-auto content-center">
                        <span> 
                          <img :src="MEDIA_URL + homeCountedIcons.area.path" class="max-width-28" alt=""/>
                          </span>
                        <span class="numbers">
                          {{ val.area }}
                        <span>{{ $t("areaSymbol") }}</span></span>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row pt-4" v-if="exchangeList.length">
        <div class="col">
          <div class="row">
            <div class="col space">
              <img src="/assets/images/icons/shop.png" class="w-24" alt="" />
              <span class="almarai-bold mx-2">{{t("home.Business_Transfer")}}</span>
            </div>
            <div class="col changeText">
              <router-link :to="'/businessTransferList'">
                <div>{{ t("home.title_2") }}</div>
              </router-link>
            </div>
          </div>
          <div class="row pt-3 display-card">
            <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(val, index) in exchangeList" :key="index">
              <div class="card card-border m-auto">
                <div class="card-body position-R">
                  <router-link :to="'/businessTransfer/'+ val.id +'?propertyType=exchange'">
                    <!-- <div class="row statusBar">
                      <div class="col-auto tag-style">
                        <span class="">{{
                          exchangeStatusChoices[val.status]
                        }}</span>
                      </div>
                    </div> -->
                    <!-- <span class="heart-icon" v-if="val.Favorites && val.Favorites.length" @click.prevent="removeFavorite(val.id, 'singlesProperties', index)">
                      <i class="fa-solid fa-heart orange-Heart"></i>
                    </span>
                    <span  class="heart-icon" v-else @click.prevent="addFavorite(val.id, 'singlesProperties', index)">
                      <i class="fa-solid fa-heart heart"></i>
                    </span> -->
                    <swiper
                      v-if="val.ExchangeMedia.length"
                      class="text-center"
                      :modules="[Autoplay, Navigation, Pagination]"
                      :autoplay="{ delay: 2500, disableOnInteraction: false }"
                      :pagination="{ clickable: true }"
                      :navigation="false"
                    >
                      <swiper-slide
                        v-for="(img, ind) in val.ExchangeMedia"
                        :key="ind"
                      >
                        <img
                          :src="MEDIA_URL + img.thumbnail"
                          alt="Slide Image"
                          class="w-100 br-radius"
                        />
                      </swiper-slide>
                    </swiper>
                    <div v-else>
                      <placeHolder />
                    </div>
                    <div class="text-title">
                      {{ val.businessName}}
                    </div>
                    <div class="row pt-1">
                      <div class="col-auto px-2 content-center">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                      </div>
                      <div class="col p-0 fontGray-73 content-center">
                        <div class="d-flex">
                          {{ val.City?.name }}
                          <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="d-flex pt-2">
                      <div class="mx-2 gray-color fonttext-14">
                        
                      </div>
                      <div class="gray-color fonttext-14">
                        
                      </div>
                    </div> -->
                    <hr class="border-color-w" />
                  </router-link>
                  <div class="row end-card space">
                    <div class="col-12 content-center" v-if="val.price !=0">
                      <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      <span class="green-color-F almarai-bold">{{val.price}}</span>
                    </div>
                    <div v-else class="col-6 col-md-7 content-center">
                      <div class="sendPrice" v-if="GET_USER">
                        <a :href="'https://wa.me/+966'+val.mobile +'?text=السلام عليكم وجدت إعلانكم في تطبيق عقار المحيسني وأرغب بالتواصل معكم بخصوص الإعلان:'+
                          ' '+val.description +' '+ val.City.name+' '+val.Neighborhood.name+' '+'https://aqaralmuhaysini.com/businessTransfer/'+val.id " class="sendPriceLink" target="_blank"
                        >
                          <span class="mx-1 green-color-4C"><i class="fa-solid fa-circle-chevron-right verticalMiddle"></i></span>
                          {{$t('sendPrice')}}
                        </a>
                      </div>
                      <div @click="poupLogin" class="sendPrice" v-if="!GET_USER">
                        <span class="mx-1 green-color-4C"><i class="fa-solid fa-circle-chevron-right verticalMiddle"></i></span>
                        {{$t('sendPrice')}}
                      </div>
                    </div>
                    <!-- <div class="col-auto content-center" v-if="val.roomsCount && val.bathroomsCount">
                      <div class="row">
                        <div class="col-auto content-center">
                          <span>
                            <img :src="MEDIA_URL+homeCountedIcons.roomsCount.path" 
                              class="max-width-28" alt=""/>
                          </span>
                          <span class="numbers">{{ val.roomsCount }}</span>
                        </div>
                        <div class="col-auto border_Icons">
                          <span>
                            <img :src="MEDIA_URL+homeCountedIcons.bathrooms.path"
                              class="max-width-28" alt=""/>
                          </span>
                          <span class="numbers">{{ val.bathroomsCount }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col-auto content-center">
                      <span> 
                        <img :src="MEDIA_URL+homeCountedIcons.area.path" class="max-width-28" alt=""/>
                        </span>
                      <span class="numbers">
                        {{ val.area }}
                      <span>{{ $t("areaSymbol") }}</span></span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row pt-4 justify-content-center">
        <div class="col-12 col-md-6 mb-3">
          <div class="card borderCard card-h">
            <div class="card-body text-center">
              <div>
                <img src="/assets/images/icons/newFrame.png" class="width-48" alt="" />
              </div>
              <div class="pt-2 almarai-bold font-22">
                {{ t("home.title_10") }}
              </div>
              <div class="gray-color">
                {{ t("home.title_11") }}
              </div>
              <div class="row justify-content-center pt-3">
                <div class="col-6 col-md-5 btn-green">
                  <router-link to="/propertymanagement" class="text-white almarai-bold">
                    {{ t("home.title_12") }}
                  </router-link>
                </div>
              </div>
              <!-- <div class="pt-3 m-auto w-75">
                <div
                  @click="poupLogin"
                  class="login-btn form-control margin-button rounded-pill"
                >
                  {{ t("home.title_12") }}
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card borderCard card-h">
            <div class="card-body text-center">
              <div>
                <img
                  src="/assets/images/icons/Frame_22.png"
                  class="width-48"
                  alt=""
                />
              </div>
              <div class="pt-2 almarai-bold font-22">
                {{ t("home.title_7") }}
              </div>
              <div class="gray-color">{{ t("home.title_8") }}</div>

              <div v-if="GET_USER" class="row justify-content-center pt-3">
                <div class="col-6 col-md-5 btn-golden">
                  <router-link to="/propertyrequest" class="text-white almarai-bold">
                    {{ t("home.title_9") }}
                  </router-link>
                </div>
              </div>

              <div v-else class="row justify-content-center pt-3">
                <div @click="poupLogin" class="col-6 col-md-5 btn-golden">
                  {{ t("home.title_9") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row pt-5 panner banner">
        <div class="col-12 col-md-6">
          <img src="/assets/images/iPhone.png" alt="" />
        </div>
        <div class="col-12 col-md-5 button-center text-center">
          <h6 class="almarai-bold font-32 pb-2">{{ t("home.title") }}</h6>
          <span>
            <a
              href="https://play.google.com/store/apps/details?id=com.almuhaysini.amaqaria"
              target="_blank"
            >
              <img
                src="/assets/images/Google-Play-2.png"
                class="btn-App"
                alt=""
              />
            </a>
          </span>
          <span class="mx-2">
            <a
              href="https://apps.apple.com/app/%D8%B9%D9%82%D8%A7%D8%B1-%D8%A7%D9%84%D9%85%D8%AD%D9%8A%D8%B3%D9%86%D9%8A/id6757802216"
              target="_blank"
            >
              <img
                src="/assets/images/App-Store-2.png"
                class="btn-App"
                alt=""
              />
            </a>
          </span>
        </div>
      </div>

      <!--begin:modal login-->
      <div class="modal bg-modal" tabindex="-1" id="loginin">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="row">
                <div class="col-auto mouse-hand" @click.prevent="closePopuplogin">
                  <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col text-center">
                  <div class="loginTitle">
                    {{$t("formLogin.title_1")}}
                  </div>
                  <p class="fontGray-73 mb-1 pt-1">
                    {{$t("formLogin.title_2")}} <br />
                    {{$t("formLogin.title_3")}}
                  </p>
                </div>
              </div>
              <div class="row pt-3 justify-content-center">
                <div class="col-12 col-md-8 mb-2">
                  <router-link to="/login">
                    <button
                      class="form-control btn-green"
                    >
                      {{$t("formLogin.title_4")}}
                    </button>
                  </router-link>
                </div>
                <div class="col-12 col-md-8 pt-1">
                  <router-link to="/register">
                    <button class="form-control btn-black">
                      {{ $t("formLogin.title_5") }}
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end:modal Login-->

      <!-- Button trigger modal -->
      <button type="button" id="city" class="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      >
        Launch demo modal
      </button>

      <!-- Modal -->
      <div class="modal fade d-none" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content br-radius-24 py-3">
            <!-- <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div> -->
            <div class="modal-body text-center">
              <div class="text-center">
                <img
                  src="/assets/images/Artboard.png"
                  class="width-80"
                  alt=""
                />
              </div>
              <h5 class="almarai-bold pt-2">
                {{$t('serviceUnavailable')}}
              </h5>
              <p class="gray-color fonttext-14">
                {{$t('workingExpanding')}}
              </p>
              <div class="row justify-content-center">
                <div class="col-12 col-md-8" @click="closePoup">
                  <div class="btn-black">{{$t('availableProperties')}}</div>
                </div>
              </div>
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save changes</button>
            </div> -->
          </div>
        </div>
      </div>


      <!-- begin:isActivePopup -->
      <button type="button" id="isActive" class="btn btn-primary d-none" data-bs-toggle="modal"
        data-bs-target="#isActiveModal"
      >
      </button>
      <div class="modal fade d-none" id="isActiveModal" tabindex="-1" aria-labelledby="isActiveModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content br-radius-24 py-3">
            <div class="modal-body text-center">
              <div class="text-center">
                <img
                  src="/assets/images/Artboard.png"
                  class="width-80"
                  alt=""
                />
              </div>
              <h5 class="almarai-bold pt-2">
                {{$t('serviceUnavailable')}}
              </h5>
              <p class="gray-color fonttext-14">
                {{$t('workingExpanding')}}
              </p>
              <div class="row justify-content-center">
                <div class="col-12 col-md-8 btn-black text-center">
                  <router-link class="text-white" :to="'/propertielist/?regionId='+defaultRegionId">
                      {{$t('availableProperties')}}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end:isActivePopup -->

      <div class="modal bg-modal" id="selectRegion" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- <div class="modal-header">
              <h5 class="modal-title">Modal title</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div> -->
            <div class="modal-body">
              <div class="row justify-content-center">
                <div class="col text-center">
                  <img
                    src="/assets/images/icons/Error.png"
                    class="width-48"
                    alt=""
                  />
                </div>
              </div>
              <div class="row justify-content-center pt-3">
                <div class="col text-center">
                  <p class="mb-1 almarai-bold">{{ $t("errorOccurred") }}</p>
                  <h6 class="small-Font">{{ $t("regionFirst") }}</h6>
                </div>
              </div>

              <div class="row pt-3 justify-content-center">
                <div class="col-8 text-center mouse-hand text-white">
                  <div class="btn-green" @click="closePopup">
                    {{ $t("continuation") }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save changes</button>
            </div> -->
          </div>
        </div>
      </div>

      <div class="modal bg-modal" id="selectNeighborhoods" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- <div class="modal-header">
              <h5 class="modal-title">Modal title</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div> -->
            <div class="modal-body">
              <div class="row justify-content-center">
                <div class="col text-center">
                  <img
                    src="/assets/images/icons/Error.png"
                    class="width-48"
                    alt=""
                  />
                </div>
              </div>
              <div class="row justify-content-center pt-3">
                <div class="col text-center">
                  <p class="mb-1 almarai-bold">{{ $t("errorOccurred") }}</p>
                  <h6 class="small-Font">{{ $t("cityFirst") }}</h6>
                </div>
              </div>

              <div class="row pt-3 justify-content-center">
                <div class="col-8 text-center mouse-hand text-white">
                  <div class="btn-green" @click="exit">
                    {{ $t("continuation") }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save changes</button>
            </div> -->
          </div>
        </div>
      </div>

      <!-- begin:Popup Share Apps -->
      <button type="button" id="btn_ShareApps" class="btn btn-primary d-none" data-bs-toggle="modal"
        data-bs-target="#shareApp"
      ></button>
      <div class="modal fade d-none" id="shareApp" tabindex="-1" aria-labelledby="shareAppLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body text-center">
              <div class="text-center">
                <img
                  src="/assets/images/icons/share-App.png"
                  class="width-80"
                  alt=""
                />
              </div>
              <p class="title_ShareApp">{{ $t("shareApps") }}</p>
              <div class="gray-color">{{ $t("share_Amazing") }}</div>
              <div class="row pt-3 justify-content-center">
                <div v-if="GET_USER" class="col-12 col-md-8 btn-black btn_share">
                  <a
                    href="https://wa.me/?text=اجهزة ابل:%0Ahttps://apps.apple.com/app/عقار-المحيسني/id6757802216%0Aاجهزة اندرويد:%0Ahttps://play.google.com/store/apps/details?id=com.almuhaysini.amaqaria%0Aتطبيق عقاري شامل - بيع وشراء عقار، إدارة الأملاك، صيانة المنازل، مدونات عقارية، وتوثيق العقود."
                    class="text-white"
                    target="_blank"
                  >
                    {{ $t("button_ShareNow") }}
                  </a>
                </div>
                <div v-else class="col-12 col-md-8 btn-black btn_share" @click="methodLogin">
                  {{ $t("button_ShareNow") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end:Popup Share Apps -->
      
      <!-- begin:Popup Share Apps affiliatePrice -->
      <button type="button" id="btn_affiliatePrice" class="btn btn-primary d-none" data-bs-toggle="modal"
        data-bs-target="#affiliatePrice"
      >
      </button>
      <div class="modal fade d-none" id="affiliatePrice" tabindex="-1" aria-labelledby="affiliatePriceLabel" aria-hidden="true">
        <div class="modal-dialog modal-Max320">
          <div class="modal-content">
            <div class="modal-body text-center">
              <div class="text-center">
                <img
                  src="/assets/images/icons/shareApps.png"
                  class="width-80"
                  alt=""
                />
              </div>
              <p class="title_ShareApp">{{$t("shareApps")}}</p>
              <div class="fontGray-73">{{$t('share_Amazing')}}</div>
              <!-- <div class="gray-color" v-if="affiliatePrice">
                {{$t("inviteFriends_register")}}
                {{affiliatePrice}}
                <span>{{$t('riyals_Yourwallet')}}</span>
              </div> -->
              <div class="row pt-3 justify-content-center">
                <div class="col-10 col-md-8 btn-green" v-if="GET_USER && !homeLoader">
                  <a :href="'https://wa.me/?text=حبيت أشاركك تطبيق عقاري أعجبني ' + ' https://applink.one/link/2LOXxL ' + 'خدمات عقارية متنوعة في مكان واحد، من البحث عن العقار إلى إدارة الأملاك والصيانة' + 'إذا جربته علمني، وش أكثر شيء شد انتباهك؟  ' + 'الرمز الترويجي لدعوة صديق'+ GET_USER_DATA.userCode" class="text-white"
                    target="_blank">
                    {{ $t("button_ShareNow") }}
                  </a>
                </div>
                <div v-else class="col-10 col-md-8 btn-green" @click="loaginFN">
                  {{ $t("button_ShareNow") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end:Popup Share Apps affiliatePrice -->
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n({ useScope: "global" });
</script>

<script>
// $('#carouselExampleAutoplaying').carousel({
//   interval: 3000,
//   cycle: true
// });
// const myCarouselElement = document.getElementById('#carouselExampleAutoplaying')

// const carousel = new bootstrap.Carousel(myCarouselElement, {
//   interval: 2500,
//   touch: false
// })
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { mapGetters } from "vuex";
export default {
  name: "HomeView",
  data() {
    return {
      hasError: false,
      searchError: false,
      message: "",
      latitude: 24.7136,
      longitude: 46.6753,
      neighborhoods: [],
      properties: [],
      propertyTypes: "",
      neighborhood: "",
      city: "",
      rows: [],
      loader: false,
      regionId: 0,
      loading: true,
      items: [],
      error: null,
      errorNumber: 0,
      itemsOb: [],
      cityObj: [],
      typeObj: [],
      typePro: [],
      regionsObj: [],
      regions: [],
      // home data
      homeCity: {},
      homeBanners: [],
      homeCountedIcons: {},
      homeFamiliesProperties: [],
      homeFeaturedProperties: [],
      homeNextReservation: null,
      homeNotificationsCount: 0,
      homeSinglesProperties: [],
      homeStatusChoices: {},
      homeExchange: [],
      regionsLoader: true,
      homeLoader: true,
      exchangeStatusChoices: {},
      activeCity: null,
      homeRegionsList: [],
      errorBuffer: null,
      exchangeList: [],
      currentOrder: null,
      orderStatus: {},
      currentOrdersCount: null,
      affiliatePrice: null,
      defaultRegionId: null,
      isActive: null,
    };
  },
  components: { Swiper, SwiperSlide },
  // setup() {
  //   return {
  //     modules: [Autoplay, Navigation, Pagination ],
  //   }
  // },
  computed: {
    ...mapGetters(["MEDIA_URL", "GET_USER", "GET_POUPSHOW", "GET_USER_DATA"]),
  },
  methods: {
    // get current user loaction
    getLocation() {
      return new Promise((resolved, rejected) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              resolved({
                longitude: position.coords.longitude,
                latitude: position.coords.latitude,
              });
            },
            (err) => {
              rejected({ status: "failed" });
            }
          );
        } else {
          rejected({ status: "failed" });
        }
      });
    },

    getData() {
      this.hasError = false;
      this.$http
        .post("/api/home", {
          latitude: this.latitude,
          longitude: this.longitude,
        })
        .then(({ data }) => {
          this.homeBanners = data.banners ?? [];
          this.homeCity = data.city ?? {};
          this.homeCountedIcons = data.countedIcons ?? {};
          this.homeFamiliesProperties = data.familiesProperties ?? [];
          this.homeFeaturedProperties = data.featuredProperties ?? [];
          this.homeNextReservation = data.nextReservation ?? null;
          this.homeNotificationsCount = data.notificationsCount ?? 0;
          this.homeSinglesProperties = data.singlesProperties ?? [];
          this.homeStatusChoices = data.statusChoices ?? {};
          this.homeRegionsList = data.regionsList ?? [];
          this.exchangeList = data.exchangeList ?? [];
          this.currentOrder = data.currentOrder;
          this.orderStatus = data.orderStatus ?? {};
          this.currentOrdersCount = data.currentOrdersCount ?? {};

          this.activeCity = data.activeCity;
          this.neighborhoods = data.neighborhoods;
          this.properties = data.propertiesNearYou;
          this.typePro = data.propertyTypies;
          this.affiliatePrice = data.affiliatePrice;
          this.defaultRegionId = data.defaultRegionId;
          this.isActive = data.regionsList.isActive;
          
          // this.regionId = data.city.regionId;
          let propertyArray = [];
          for (let p = 0; p < this.typePro.length; p++) {
            propertyArray.push({
              id: this.typePro[p].id,
              text: this.typePro[p].name,
            });
          }
          this.typeObj = propertyArray;
          // this.citiesList();
          // document.getElementById('selectRegion').style.display ='block'
          if (this.regionId) {
            this.citiesList();
          }
          this.homeLoader = false;
          window.scroll(0, 0);
        })
        .catch((err) => {
          // console.log(err);
          this.homeLoader = false;
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          window.scroll(0, 0);
        });
    },

    regionsList() {
      (this.searchError = false),
        this.$http.get("/api/regions/list").then((res) => {
        this.regions = res.data.regions;
        let regionOption = [];
        for (let R = 0; R < this.regions.length; R++) {
          regionOption.push({
            id: this.regions[R].id,
            text: this.regions[R].name,
          });
        }
        this.regionsObj = regionOption;
        this.getData();
        this.regionsLoader = false;
      })
      .catch((err) => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.searchError = true;
        this.regionsLoader = false;
      });
    },

    citiesList() {
      this.searchError = false;
      this.$http
        .get("/api/cities/list?regionId=" + this.regionId)
        .then((res) => {
          // console.log(res);
          this.rows = res.data.cities;
          let cityOptions = [];
          for (let i = 0; i < this.rows.length; i++) {
            cityOptions.push({ id: this.rows[i].id, text: this.rows[i].name });
          }
          this.cityObj = cityOptions;
          this.loader = false;
        })
        .catch((err) => {
          // console.log(err);
          this.loader = false[(this.message, this.errorNumber)] =
            this.$globalError(err, true);
          this.searchError = true;
        });
    },

    neighborhoodList() {
      this.searchError = false;
      this.$http
        .get("/api/neighborhoods/list?cityId=" + this.city)
        .then((res) => {
          // console.log(res);
          this.items = res.data.neighborhoods;
          let optionsArray = [];
          for (let i = 0; i < this.items.length; i++) {
            optionsArray.push({
              id: this.items[i].id,
              text: this.items[i].name,
            });
          }
          this.itemsOb = optionsArray;
          this.loading = false;
        })
        .catch((err) => {
          // console.log( err);
          this.loading = false;
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.searchError = true;
        });
    },

    addFavorite(id, dataName, index) {
      this.hasError = false;
      if (!this.GET_USER) {
        document.getElementById("loginin").style.display = "block";
        return false;
      }
      this.$http
        .post("/api/favorites/add", {
          propertyId: id,
        })
        .then((res) => {
          // console.log(res);
          if (dataName == "properties") {
            this.properties[index].Favorites = [{}];
          }
          if (dataName == "featuredProperties") {
            this.homeFeaturedProperties[index].Favorites = [{}];
          }
          if (dataName == "familiesProperties") {
            this.homeFamiliesProperties[index].Favorites = [{}];
          }
          if (dataName == "singlesProperties") {
            this.homeSinglesProperties[index].Favorites = [{}];
          }
          this.loading = false;
        })
        .catch((err) => {
          // console.log(err);
          this.loading = false;
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
        });
    },

    removeFavorite(id, dataName, index) {
      if (!this.GET_USER) {
        document.getElementById("loginin").style.display = "block";
        return false;
      }
      this.$http
        .delete("/api/favorites/remove/" + id)
        .then((res) => {
          // console.log(res);
          if (dataName == "properties") {
            this.properties[index].Favorites = [];
          }
          if (dataName == "featuredProperties") {
            this.homeFeaturedProperties[index].Favorites = [];
          }
          if (dataName == "familiesProperties") {
            this.homeFamiliesProperties[index].Favorites = [];
          }
          if (dataName == "singlesProperties") {
            this.homeSinglesProperties[index].Favorites = [];
          }
          this.loading = false;
        })
        .catch((err) => {
          // console.log(err);
          this.loading = false;
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
        });
    },

    closePopuplogin() {
      document.getElementById("loginin").style.display = "none";
    },

    poupLogin() {
      document.getElementById("loginin").style.display = "block";
    },
    loaginFN(){
      document.getElementById('btn_affiliatePrice').click();
      document.getElementById("loginin").style.display = "block";
    },
    methodLogin(){
      document.getElementById('btn_ShareApps').click();
      document.getElementById("loginin").style.display = "block";
    },

    exchangesList() {
      this.$http.get("/api/exchanges/list").then((res) => {
        // console.log(res);
        this.homeExchange = res.data.rows;
        this.exchangeStatusChoices = res.data.statusChoices;
        this.homeLoader = false;
      })
      .catch((err) => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.homeLoader = false;
      });
    },
    closePoup() {
      document.getElementById("city").click();
    },

    checkRegions() {
      if (!this.regionId) {
        document.getElementById("selectRegion").style.display = "block";
      }
    },

    checkNeighborhoods() {
      if (!this.city) {
        document.getElementById("selectNeighborhoods").style.display = "block";
      }
    },

    closePopup() {
      document.getElementById("selectRegion").style.display = "none";
    },
    exit() {
      document.getElementById("selectNeighborhoods").style.display = "none";
    },

    checkUser(){
      if(!this.GET_USER){
        document.getElementById("loginin").style.display = "block";
      }
    },

    deleteImg(id, index){
      swal({
        title: this.$t('confirm_title'),
        // text: "You will not be able to recover this imaginary file!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: this.$t('confirmButtonText'),
        cancelButtonText: this.$t('cancelButtonText'),
        closeOnConfirm: false
      },()=> this.deleteMedia(id, index));
    },
    deleteMedia(id, index){
      this.$http.delete("/api/exchanges/delete/"+id).then(res => {
        this.exchangeList.splice(index, 1);
        swal(this.$t('confirmMessage'));
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      })
    },
    activeRegion(){
      document.getElementById("isActive").click();
    }
  },
  created() {
    // this.getLocation()
    //   .then((data) => {
    //     this.longitude = data.longitude;
    //     this.latitude = data.latitude;
    //     this.regionsList();
    //   })
    //   .catch(() => {
    //     this.regionsList();
    //   });
    window.scroll(0, 0);
    this.regionsList();
    // this.exchangesList();

    setTimeout(() => {
      if (this.activeCity == false && this.GET_POUPSHOW) {
        document.getElementById("city").click();
        this.$store.commit("SET_POUPSHOW");
      }
    }, 2000);

    setTimeout(() => {
      const width = window.innerWidth;
      const el = document.getElementById("btn_ShareApps");
      if (el && width  <= 768 && !this.affiliatePrice ) {
        el.click();
      }
    }, 10000);

    setTimeout(() => {
      const width = window.innerWidth;
      const el = document.getElementById("btn_affiliatePrice");
      if (el && width  <= 768 && this.affiliatePrice > 0 ) {
        el.click();
      }
    }, 10000);

    // if(window.getComputedStyle(document.getElementById("mobNavBtn"),null).getPropertyValue('display') == 'block' && window.getComputedStyle(document.getElementById("navbarNavDropdown"),null).getPropertyValue('display') == 'block'){
    //   document.getElementById("mobNavBtn").click();
    // }
  },
  mounted() {
    const autoPaly = () => {
      if(typeof bootstrap == 'undefined' || typeof bootstrap?.Carousel == 'undefined'){
        setTimeout(() => autoPaly(), 200);
        return;
      }
      try {
        setTimeout(() => {
          const el = document.querySelector('#carouselExampleAutoplaying');
          if(el && el != 'undefined'){
            const carousel = new bootstrap.Carousel(
              document.querySelector('#carouselExampleAutoplaying'),
              {
                interval: 3000,
                ride: 'carousel'
              }
            );
          }
        }, 400);
      } catch (error) {
        this.errorBuffer = error;
      }
    }
    autoPaly();
  },
};
</script>
<style scoped>
.form-select {
  background-position: right 0.75rem center;
}

.carousel-indicators button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ddd;
}

.carousel-indicators .active {
  background-color: #fff;
}
</style>
